module.exports = __webpack_public_path__ + "img/copy-account.ee8f64b3.svg";